import Laurel121 from '../../../Media/BSD/Navapark/Laurel 12.webp'
import Laurel122 from '../../../Media/BSD/Navapark/Laurel 12.webp'





const Laurel12images =[
Laurel121,Laurel122
]

export default Laurel12images;